import { render } from "./PostTextComponent.vue?vue&type=template&id=7e265f38&scoped=true&ts=true"
import script from "./PostTextComponent.vue?vue&type=script&lang=ts"
export * from "./PostTextComponent.vue?vue&type=script&lang=ts"

import "./PostTextComponent.vue?vue&type=style&index=0&id=7e265f38&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e265f38"]])

export default __exports__